import React, { useEffect, useState } from "react";
import Checkout from "./checkout";
import CheckoutMobile from "./CheckoutMobile";

export default function ResponsiveCheckout() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <CheckoutMobile /> : <Checkout />;
}